import axios from 'axios';
import { getAccessToken } from '../utils/Auth.util';
import { determineMemberFieldsBasedOnCoverage } from '../utils/OrchRequestUtil.js';
import { MICRO_FRONTEND_STARGATE_KEY } from '../constants/index';
/**
 * This function is used to get the vision price for the selected service and member details provided by the user in the form
 * @param {*} formValues
 * @param {*} memberDetails
 * @param {*} correlationId
 * @returns
 */
export const getVisionPrice = async (formValues, memberDetails, correlationId) => {
    const url = process.env.UTILS_PROXY_URL;
    const payload = buildRequestPayload(formValues, memberDetails);
    try {
        const headers = await buildRequestHeaders(correlationId);
        const request = buildRequestBody(payload);
        const response = await axios.post(url, request, { headers: headers });
        return response.data;
    } catch (error) {
        console.error(
            `Error in getVisionPrice Function when calling '${process.env.UTILS_PROXY_URL}' endpoint: ${error}`
        );
        throw error;
    }
};
// Helper functions to build the request payload, headers and body
export const buildRequestPayload = (formValues, memberDetails) => {
    const selectedServiceObj = formValues.selectedService.value;
    const { eligibilityIdentifier } = determineMemberFieldsBasedOnCoverage(
        memberDetails,
        selectedServiceObj.fullCarePath.coverageTypeCode
    );
    return {
        member: buildMemberObject(memberDetails, formValues, eligibilityIdentifier),
        benefitTiers: ['IN-NETWORK', 'OUT-NETWORK'],
        billingCodes: [selectedServiceObj?.fullCarePath?.mainBillingCode],
    };
};
// Helper functions to build the member object
const buildMemberObject = (memberDetails, formValues, eligibilityIdentifier) => {
    return {
        firstName: memberDetails?.demographics?.name?.firstName,
        lastName: memberDetails?.demographics?.name?.lastName,
        dateOfBirth: formValues?.dateOfBirth?.value,
        memberId: formValues?.memberNumber?.value,
        groupId: formValues?.groupNumber?.truncated,
        userIdentifier: memberDetails?.userIdentifier,
        eligibilityIdentifier: eligibilityIdentifier,
        dependentSequenceNumber: memberDetails?.demographics?.dependentSeqNbr,
    };
};
// Helper functions to build the request headers
const buildRequestHeaders = async (correlationId) => {
    const token = await getAccessToken(MICRO_FRONTEND_STARGATE_KEY);
    const HCP_Stargate_token = await getAccessToken(
        process.env.ENV == 'uat' ? 'HCP_NonProd_Stargate_token' : 'HCP_Stargate_token',
        process.env.ACCESS_TOKENS_URL_NONPROD
    );
    return {
        'Content-Type': 'application/json',
        'X-Upstream-Env':
            process.env.ENV === 'prod' ? 'prod' : process.env.ENV === 'uat' ? 'uat' : 'integration',
        Authorization: 'Bearer ' + token,
        'x-downstream-authorization': HCP_Stargate_token,
        ...(correlationId && {
            'x-epe-correlationid': correlationId,
        }),
    };
};
// Helper functions to build the request body
const buildRequestBody = (payload) => {
    return {
        method: 'POST',
        targetUrl: 'VISION_API_URL',
        path: '',
        payload: payload,
    };
};
